module.exports = __webpack_public_path__ + "img/_logo.7ef18c80.svg";